<div class="card card-custom gutter-b card-strech">
    <!-- <div class="card-header card-header-tabs-line">
        <div class="card-toolbar">
            <ul class="nav nav-tabs nav-bold nav-tabs-line">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': notes }" data-toggle="tab" href="#pills-notes"
                        (click)="ver('notes')">
                        <span class="nav-text">Appointment</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': recall }" id="pills-recall-tab" data-toggle="tab"
                        data-bs-target="#pills-recall" href="#pills-recall" (click)="ver('recall')">
                        Referred
                    </a>
                </li>
            </ul>
        </div>
    </div> -->
    <div class="row">
        <div class="col">
            <ngx-work-referred [pet_no]="pet_no"></ngx-work-referred>
        </div>
    </div>

    <hr>

    <div class="row">
        <div class="col">
            <ngx-work-appointments [pet_no]="pet_no" [client_no]="client_no" [type]="'pet'"></ngx-work-appointments>
        </div>
    </div>
    <!-- <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade" [ngClass]="{ 'show active': notes }" id="pills-notes" role="tabpanel"
            aria-labelledby="pills-notes-tab">
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': recall }" id="pills-recall" role="tabpanel"
            aria-labelledby="pills-recall-tab">
        </div>
    </div> -->


    <!-- <div class="accordion" id="accordionExample">
        <div class="card">
            <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                        data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Appointment
                    </button>
                </h2>
            </div>
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="headingTwo">
                <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                        data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Referred
                    </button>
                </h2>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
            </div>
        </div>
    </div> -->
</div>